import productTranslations from "./productTranslations";
import { cn, en, ja } from "./translations";

export default {
  en: {
    translations: {
      ...en.translations,
      "Select Category": "Select Category",
      pagingInfo: "Search results {{totalResults}}",
      件: "",
      "Quick search": "Quick search",
      "mosfet-relays": "MOS FET Relays",
      "signal-relay_power-relays": "Signal and Power Relays",
      "Parametric search": "Parametric search",
      "Advanced search": "Advanced search",
      "Close advanced search": "Close advanced search",
      field_faq_product_categories: "Products",
      field_faq_question_categories: "Products",
      Durability: "Durability",
      Reset: "Reset",
      "Select all search results": "Select all search results",
      Related: "Related",
      "New arrival order": "New arrival order",
      "Relevance order": "Relevance order",
      "Search results": "List of search results",
      "Download the catalog": "Download the catalog",
      "Download search results in CSV format": "Download search results",
      Format: "Format",
      "About CAD data usage": "About CAD data usage",
      "Inquiries about CAD data": "Inquiries about CAD data",
      Notes: "Notes",
      "Click here for inquiry form": "Click here for inquiry form",
      inquiry: "inquiry",
      "Frequently asked questions on products":
        "Frequently asked questions on products",
      "Search by keyword": "Search by keyword",
      "Product category narrowing down": "Product category narrowing down",
      "Search by category": "Search by category",
      "Example: G3VM-101DR": "Example: G3VM-101DR",
      "If the information you are looking for is not found":
        "If the information you are looking for is not found",
      "Contact Us": "Contact Us",
      "Making an inquiry using the form": "Making an inquiry using the form",
      prev: "Prev",
      next: "Next",
      "Distributor Inventory": "Distributor Inventory",
      America: "America",
      Japan: "Japan",
      Europe: "Europe",
      China: "China",
      "2D-3D LINK": "2D-3D Link",
      "2D/3D CAD": "2D/3D CAD",
      "Login/Register": "Login/Register",
      Distributor: "Distributor",
      "Inventory number": "Inventory number",
      "Buy Online": "Buy Online",
      "mosfet-relays": "MOS FET Relays",
      "signal-relay_power-relays": "Signal and Power Relays",
      "automotive-relays": "Automotive Relays",
      "flow-sensors": "Flow Sensors",
      "photomicro-sensors_reflective-types":
        "Photomicro Sensors Reflective Types",
      "photomicro-sensors_transmissive-types":
        "Photomicro Sensors Transmissive Types",
      connectors: "Connectors",
      "automotive-basic-switches": "Automotive Basic Switches",
      "dip-switches": "DIP Switches",
      "toggle_pushbutton-switches": "Toggle/Pushbutton Switches",
      "rocker-switches": "Rocker Switches",
      "tactile-switches": "Tactile Switches",
      "door-switchs_power-switches": "Door Switches/Power Switches",
      "detection-switches": "Detection Switches",
      "basic-switches": "Basic Switches",
      "e.g.：G3VM-101DR": "e.g.：G3VM-101DR",
      "The page you are looking for could not be found. Please try a different keyword.":
        "The page you are looking for could not be found. Please try a different keyword.",
      "Bundle Category": "Information",
      product_type: "Products",
      others: "Others",
      faq: "FAQ",
      news: "What's New",
      "There is no distributor inventory.":
        "There is no distributor inventory.",
      "Loading ...": "Loading ...",
      "No file to download!": "No file to download!",
      "Range": "Range",
      "Membership Only": "Membership Only",
      ...productTranslations["en"],
    },
  },
  ja: {
    translations: {
      ...ja.translations,
      ECAD: "ECAD",
      Precaution: "注意事項",
      "2D-3D LINK": "2D-3D リンク",
      "2D/3D CAD": "2D/3D CAD",
      "Login/Register": "ログイン/会員登録",
      "mosfet-relays": "MOS FETリレー",
      "signal-relay_power-relays": "信号用リレー パワーリレー",
      prev: "前へ",
      next: "次へ",
      China: "中国",
      America: "アメリカ",
      Europe: "ヨーロッパ",
      Japan: "日本",
      Korea: "韓国",
      "Asia Pacific": "アジア太平洋地域",
      "Distributor Inventory": "外部ECサイト",
      "Example: G3VM-101DR": "例：G3VM-101DR",
      inquiry: "お問い合わせ",
      "Click here for inquiry form": "お問い合わせフォームはこちら",
      "Product category narrowing down": "製品カテゴリ絞り込み",
      "Search by category": "カテゴリから検索する",
      "Search by keyword": "キーワードから検索する",
      "Frequently asked questions on products": "製品に関するよくある質問",
      "About CAD data usage": "CADのデータ使用について",
      "Inquiries about CAD data": "CADデータに関するお問い合わせ",
      Format: "形式",
      "Download the catalog": "カタログをダウンロードする",
      "Download search results in CSV format": "検索結果をダウンロードする",
      pagingInfo: "検索結果 {{totalResults}}件",
      Related: "関連する",
      "New arrival order": "新着順",
      "Relevance order": "関連度順",
      "Select all search results": "検索結果を全て選択する",
      Reset: "リセット",
      Durability: "耐久性",
      "Quick search": "クイック検索",
      Shape: "形状",
      Datasheet: "データシート",
      "Parametric search": "パラメトリックサーチ",
      "Search results": "サイト内検索結果",
      "Search results list": "検索結果一覧",
      "Select Category": "キーワード検索時のカテゴリ選択",
      relay: "リレー",
      switch: "スイッチ",
      "Total Results": "検索結果",
      "Product Category": "製品カテゴリ絞り込み",
      "FAQ Category": "お悩みから絞り込む",
      Relevance: "関連する",
      field_faq_product_categories: "Products",
      field_faq_question_categories: "Questions",
      "Search FAQ": "Search FAQ",
      "When you cannot find the information you are looking for":
        "お調べの情報が見つからない時",
      Notes: "御注意事項",
      "If the information you are looking for is not found":
        "お調べの情報が見つからないとき",
      "Contact Us": "お問い合わせ",
      "Making an inquiry using the form": "お問い合わせフォームはこちら",
      Page: "ページ",
      "File Format": "ファイル形式",
      "Filter by information": "情報別絞り込み",
      "Search Results": "検索結果",
      "Advanced search": "詳細検索",
      "Close advanced search": "詳細検索を閉じる",
      Distributor: "外部ECサイト",
      "Inventory number": "購入可能数",
      Model: "形式",
      "Buy Online": "購入する",
      "e.g.：G3VM-101DR": "例：G3VM-101DR",
      "The page you are looking for could not be found. Please try a different keyword.":
        "お探しのページが見つかりませんでした。別のキーワードをお試しください。",
      "mosfet-relays": "MOS FETリレー",
      "signal-relay_power-relays": "信号用リレー パワーリレー",
      "automotive-relays": "車載用リレー",
      "flow-sensors": " 流量センサ",
      "photomicro-sensors_reflective-types": "フォト・マイクロセンサ",
      "photomicro-sensors_transmissive-types": "フォト・マイクロセンサ透過形",
      connectors: "コネクタ",
      "automotive-basic-switches": "車載用マイクロスイッチ",
      "dip-switches": "ディップスイッチ",
      "toggle_pushbutton-switches": "トグル/プッシュスイッチ",
      "rocker-switches": "ロッカースイッチ",
      "tactile-switches": "タクタイルスイッチ",
      "door-switchs_power-switches": "ドア/電源スイッチ",
      "detection-switches": "検出スイッチ",
      "basic-switches": "マイクロスイッチ",
      "Bundle Category": "情報",
      news: "新着情報",
      product_type: "製品情報",
      faq: "よくある質問",
      others: "その他",
      "There is no distributor inventory.": "販売店在庫はありません。",
      "Loading ...": "読み込み中...",
      "No file to download!": "ダウンロードするファイルがありません！",
      "Range": "有効値",
      "Membership Only": "会員専用",
      ...productTranslations["jp"],
    },
  },
  zh_hans: {
    translations: {
      ...cn.translations,
      Format: "格式",
      Shape: "形状",
      Datesheet: "数据表",
      "Parametric search": "参数搜索",
      "Search Results": "寻找结果",
      Filters: "滤器",
      "Advanced search": "高级搜索",
      "Close advanced search": "关闭高级搜索",
      prev: "以前的",
      next: "下一个",
      Reset: "重置",
      "Quick search": "快速搜索",
      "Download the catalog": "下载目录",
      "Download search results in CSV format": "下载搜索结果",
      "Select all search results": "选择所有搜索结果",
      "Search results": "搜索结果",
      pagingInfo: "搜索结果 {{totalResults}}的",
      "Distributor Inventory": "经销商库存",
      Distributor: "经销商",
      "Inventory number": "库存数量",
      Model: "型号",
      "Buy Online": "购买",
      "e.g.：G3VM-101DR": "例如：G3VM-101DR",
      "The page you are looking for could not be found. Please try a different keyword.":
        "您正在寻找的页面无法找到。请换个关键词。",
      "mosfet-relays": "MOS FET继电器",
      "signal-relay_power-relays": "信号用继电器功率继电器",
      "automotive-relays": "车载继电器",
      "flow-sensors": "流量传感器",
      "photomicro-sensors_reflective-types": "微型光电传感器反射型",
      "photomicro-sensors_transmissive-types": "微型光电传感器透过型",
      connectors: "推荐产品",
      "automotive-basic-switches": "车载用基本开关",
      "dip-switches": "DIP开关",
      "toggle_pushbutton-switches": "按钮开关/显示灯",
      "rocker-switches": "船形开关",
      "tactile-switches": "轻触开关",
      "door-switchs_power-switches": "门用开关/电源开关",
      "detection-switches": "检测开关",
      "basic-switches": "基本开关",
      "No file to download!": "没有文件可下载！",
      Datasheet: "数据表",
      "Bundle Category": "信息",
      news: "什么是新的",
      product_type: "产品",
      faq: "常见问题",
      others: "其他",
      "There is no distributor inventory.": "没有经销商库存。",
      "Loading ...": "正在加载...",
      Datasheet: "数据表",
      Precaution: "注意事项",
      "Search by keyword": "按关键字搜索",
      "Select Category": "选择类别",
      "Search by category": "按类别搜索",
      "Search results list": "搜索结果列表",
      "New arrival order": "新到货订单",
      "Relevance order": "相关顺序",
      "Product Category": "产品类别",
      "Frequently asked questions on products": "常见问题解答（FAQ）",
      "FAQ Category": "常见问题解答（FAQ）类别",
      "If the information you are looking for is not found":
        "如果没有找到您要查找的信息",
      "Contact Us": "服务中心eService",
      "Making an inquiry using the form": "通过咨询表进行咨询",
      "Range": "Range",
      "Membership Only": "会员専用",
      ...productTranslations["cn"],
    },
  },
};
